var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{},[_c('dv-border-box-12',[_c('dv-scroll-board',{staticStyle:{"width":"100%","height":"350px"},attrs:{"config":_vm.scrollData}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }